import { Collapse, Spin, Switch, useToast } from '@bfe/moly';
import { useEffect, useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import {
  getEmailSubscriptionsList,
  userSetSubscriptions,
} from '@/services/setting';
import {
  IEmailSubscriptions,
  ISwitchListItem,
} from '@/services/types/settings';
import { sensors } from '@/utils/skynet';

const SwitchListItem = (props: {
  item: ISwitchListItem;
  switchLoading: boolean;
  currentModuleId: number | undefined;
  // showSample: () => void;
  handleUserSubscription: (checked: boolean, item: ISwitchListItem) => void;
}) => {
  const [$t] = useI18nContext();
  const { item, currentModuleId, switchLoading, handleUserSubscription } =
    props;

  return (
    <div className="email-sub-collapse-item ">
      <div className="email-sub-collapse-title">
        {$t(`name_${item.moduleId}`)}
      </div>
      <div className="email-sub-collapse-switch">
        {/* <Popover
          content={$t(`desc_${item.moduleId}`)}
          trigger="click"
          placement="right"
          showArrow={false}
        >
          <div className="email-sub-collapse-btn" onClick={showSample}>
            {$t('Sample')}
          </div>
        </Popover> */}
        <Switch
          loading={switchLoading && item.moduleId === currentModuleId}
          checked={!item.status}
          onCheckedChange={(checked: boolean) => {
            handleUserSubscription(checked, item);
          }}
        />
      </div>
    </div>
  );
};

const EmailSubscription = () => {
  const [$t] = useI18nContext();
  const [emailSubscriptionData, setEmailSubscriptionData] = useState<
    IEmailSubscriptions[]
  >([]);
  const [subscriptionModules, setSubscriptionModules] = useState<string[]>([]);
  const [collapseKey, setCollapseKey] = useState<number[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [switchLoading, setSwitchLoading] = useState<boolean>(false);
  const [currentModuleId, setCurrentModuleId] = useState<number | undefined>();
  const { toast, EToastType } = useToast();

  // 初始化邮件订阅
  const initEmailSubscriptionModules = (data: IEmailSubscriptions[]) => {
    const int_sub_modules: string[] = [];
    const collapseKeys: number[] = [];
    data.map((item) => {
      if (item.modules.length) {
        item.modules.map((subItem) => {
          if (subItem.status) {
            int_sub_modules.push(String(subItem.moduleId));
          } else {
            collapseKeys.push(subItem.parentId);
          }
        });
      }
    });
    const finalCollapseKeys = Array.from(new Set(collapseKeys));
    setCollapseKey(finalCollapseKeys);
    setSubscriptionModules(int_sub_modules);
  };

  // 获取邮件订阅
  const getEmailSubscriptions = (initFlag: boolean) => {
    getEmailSubscriptionsList()
      .then((res) => {
        const result = res as IEmailSubscriptions[];
        if (result) {
          if (initFlag) initEmailSubscriptionModules(result);
          setEmailSubscriptionData(result);
        }
      })
      .catch((error) => {
        const msg = error?.ret_msg;
        toast({
          iconType: EToastType.FAIL,
          title: msg,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 用户开启取消订阅
  const handleUserSubscription = (checked: boolean, item: ISwitchListItem) => {
    // 记录当前模块id
    setCurrentModuleId(item.moduleId);
    // 记录 switch module状态
    let sub_modules: string[] = [];
    let uniqueSubModules: string[] = [];
    if (checked) {
      sub_modules = subscriptionModules.filter(
        (i: string) => i != String(item.moduleId),
      );
      sensors?.click({
        page_section: 'email-subscription',
        button_name: 'switch',
        status: 'open',
      });
    } else {
      subscriptionModules.push(String(item.moduleId));
      sub_modules = subscriptionModules;
      sensors?.click({
        page_section: 'email-subscription',
        button_name: 'switch',
        status: 'close',
      });
    }
    uniqueSubModules = Array.from(new Set(sub_modules));
    setSubscriptionModules(uniqueSubModules);
    const subscription_modules: string = uniqueSubModules.join(',');
    setSwitchLoading(true);
    userSetSubscriptions(subscription_modules)
      .then((res) => {
        if (res) {
          getEmailSubscriptions(false);
          toast({
            iconType: EToastType.SUCCESS,
            title: $t('securityWithdrawCoins.settingSuccess'),
          });
        }
      })
      .catch((error) => {
        const msg = error?.ret_msg;
        toast({
          iconType: EToastType.FAIL,
          title: msg,
        });
        uniqueSubModules = uniqueSubModules.filter(
          (i: string) => i != String(item.moduleId),
        );
        setSubscriptionModules(uniqueSubModules);
      })
      .finally(() => {
        setSwitchLoading(false);
      });
  };

  // 展示样例
  // const handleClickSample = () => {
  //   sensors?.click({
  //     page_section: 'email-subscription',
  //     button_name: 'sample',
  //   });
  // };

  // 处理邮件订阅数据
  const handleItem = (itemRes: IEmailSubscriptions[]) => {
    const result = itemRes.map((item: IEmailSubscriptions) => {
      return {
        label: (
          <span className="email-sub-collapse-size">
            {$t(`name_${item.moduleId}`)}
          </span>
        ),
        key: item.moduleId,
        children: item.modules.map((moduleData: ISwitchListItem) => {
          return (
            <SwitchListItem
              item={moduleData}
              key={moduleData.moduleId}
              switchLoading={switchLoading}
              currentModuleId={currentModuleId}
              // showSample={handleClickSample}
              handleUserSubscription={handleUserSubscription}
            />
          );
        }),
      };
    });
    return result;
  };

  useEffect(() => {
    getEmailSubscriptions(true);
    sensors?.exposure?.({
      page_section: 'email-subscription',
    });
  }, []);

  return (
    <Spin spinning={loading}>
      <div className="email-sub-container">
        <div className="email-sub-collapse">
          <Collapse
            items={
              emailSubscriptionData ? handleItem(emailSubscriptionData) : []
            }
            value={collapseKey}
            onChange={(a) => setCollapseKey(a)}
            type="multiple"
          />
        </div>
      </div>
    </Spin>
  );
};

export default EmailSubscription;
